export const winners = [
  {
    user_id: 'eo3ZvXXYZzgjeZ2tkZia360g5hF2',
    user_name: 'Lorenzolabs',
    full_name: 'Leo Lorenzo',
    score: 8265,
    rank: 1,
    quote:
      "The Soopra AI contest showed me what's possible when creativity meets technology. Building an AI that reflected me felt powerful and personal.",
    profile_pic_url:
      'https://firebasestorage.googleapis.com/v0/b/mimio---db.appspot.com/o/images%2Feo3ZvXXYZzgjeZ2tkZia360g5hF2%2Fprofile_pic.jpg?alt=media',
  },
  {
    user_id: 'LOugpliWPpMlW8Ix1NfWHbgbpfF2',
    user_name: 'Babaconcept',
    full_name: 'BabaOnchain',
    score: 7672,
    rank: 2,
    quote:
      'Participating in the Soopra contest was an incredible experience! I loved how the platform let me track my progress, reflect through journaling and other toolBuilding a digital version of myself to keep working while I was away. The leaderboard kept me motivated and the community made it fun and engaging. Soopra isn’t just a contest for me. It’s a tool that help one grow, experiment, and level up personal brand.',
    profile_pic_url:
      'https://firebasestorage.googleapis.com/v0/b/mimio---db.appspot.com/o/images%2FLOugpliWPpMlW8Ix1NfWHbgbpfF2%2Fprofile_pic.jpg?alt=media',
  },
  {
    user_id: 'MJg0asLoo4UEqARHkwANWzLf7cb2',
    user_name: 'david_noah',
    full_name: 'David',
    score: 6063,
    rank: 3,
    quote:
      "I love how Soopra feels different. My persona sounds like me, just a smarter version that's online 24/7.",
    profile_pic_url:
      'https://firebasestorage.googleapis.com/v0/b/mimio---db.appspot.com/o/images%2FMJg0asLoo4UEqARHkwANWzLf7cb2%2Fprofile_pic.jpg?alt=media',
  },
];
